import { render, staticRenderFns } from "./GenerateXLSXButon.vue?vue&type=template&id=6a68690b&"
import script from "./GenerateXLSXButon.vue?vue&type=script&lang=js&"
export * from "./GenerateXLSXButon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports